module.exports = __webpack_public_path__ + "static/media/add subject.b464ac90.svg";